document.addEventListener('DOMContentLoaded', function () {
    const labels = document.querySelectorAll(`.variant-pill`);
    labels.forEach(label => {
        label.addEventListener('click', function (e) {
            const productForm = document.querySelector("[bss-b2b-main-product-form]");
            BSS_B2B.observer.productSubject.notifyObserver('VariantChange', 'VariantSelectChange', { productForm });
        });
    });
});